import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';

export interface MobileOriginSingleRowDataProps {
  name: string;
  caption: string;
  redirect: string;
}

export interface MobileOriginSingleRowProps
  extends MobileOriginSingleRowDataProps {
  onChange?: ({ redirect, caption }: MobileOriginSingleRowDataProps) => void;
}

const MobileOriginSingleRow: React.FC<MobileOriginSingleRowProps> = ({
  name,
  caption = '',
  redirect = '',
  onChange,
}) => {
  const handleChange = async (newRedirect: string) => {
    if (onChange) onChange({ name, caption, redirect: newRedirect });
  };

  return (
    <FsFormFullWidthContainer>
      <FsSimpleInput
        fsVariant="outlined"
        fullWidth
        label={caption}
        placeholder={defaultLocales.redirectUrl}
        value={redirect}
        onChange={(e) => handleChange(e.target.value)}
      />
    </FsFormFullWidthContainer>
  );
};

export default MobileOriginSingleRow;
